import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
const offerItems = [{
  title: 'THE AI FIREWALL EBOOK',
  desc: 'The 60-page tactical bible to career immunity.',
  value: '$197',
  isMain: true
}, {
  title: 'BONUS 1: The C-Suite Prompt Vault',
  desc: 'Commands that make AI think like a CEO.',
  value: '$97'
}, {
  title: 'BONUS 2: The AI Tool-Stack 2026',
  desc: 'No more fluff. Just the 10 tools that matter.',
  value: '$47'
}, {
  title: 'BONUS 3: LinkedIn Profile Makeover',
  desc: 'Become a magnet for high-paying recruiters.',
  value: '$67'
}, {
  title: "BONUS 4: The 'AI-Raise' Script",
  desc: 'The exact words to get paid more for your new efficiency.',
  value: '$97'
}, {
  title: 'BONUS 5: Meeting Freedom Protocol',
  desc: 'Delete 14 hours of meetings from your week.',
  value: '$37'
}];
export const OfferStack = () => {
  return <section className="py-20 sm:py-32 px-4 bg-white" id="checkout" data-id="element-93">
      <div className="max-w-4xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-95">
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-brand-dark mb-4" data-id="element-96">
            Here is everything you get today
          </h2>
          <div className="w-24 h-1 bg-brand-accent mx-auto" data-id="element-97"></div>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-98">
          {offerItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`flex items-start sm:items-center gap-4 p-6 border rounded-sm ${item.isMain ? 'bg-brand-dark text-brand-light border-brand-dark shadow-xl' : 'bg-brand-light border-brand-dark/10'}`} data-id="element-99">
              <CheckCircle2 className={`w-6 h-6 shrink-0 mt-1 sm:mt-0 ${item.isMain ? 'text-brand-accent' : 'text-brand-accent'}`} data-id="element-100" />
              <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4" data-id="element-101">
                <div data-id="element-102">
                  <h3 className={`font-bold text-lg ${item.isMain ? 'text-brand-gold' : 'text-brand-dark'}`} data-id="element-103">
                    {item.title}
                  </h3>
                  <p className={item.isMain ? 'text-brand-light/80' : 'text-brand-dark/70'} data-id="element-104">
                    {item.desc}
                  </p>
                </div>
                <div className={`font-bold whitespace-nowrap ${item.isMain ? 'text-brand-light' : 'text-brand-dark/50'}`} data-id="element-105">
                  Value: {item.value}
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div id="get-access" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-dark text-brand-light p-8 sm:p-12 rounded-sm text-center shadow-2xl border-t-4 border-brand-accent scroll-mt-32" data-id="element-106">
          <div className="text-xl sm:text-2xl font-medium mb-4 text-brand-light/80" data-id="element-107">
            TOTAL VALUE:{' '}
            <span className="line-through decoration-brand-accent decoration-2" data-id="element-108">
              $542+
            </span>
          </div>
          <div className="font-serif text-4xl sm:text-6xl font-bold mb-8" data-id="element-109">
            GET IT ALL TODAY FOR ONLY:{' '}
            <span className="text-brand-gold" data-id="element-110">$47</span>
          </div>

          <a href="https://floctiva.com/cart/53063149912380:1" onClick={() => trackAddToCart()} className="inline-block w-full sm:w-auto bg-brand-accent text-white font-bold text-xl px-10 py-5 rounded-sm hover:bg-brand-accent/90 transition-all transform hover:scale-105 shadow-lg shadow-brand-accent/20" data-id="element-111">
            YES! I WANT TO BECOME UNREPLACEABLE
          </a>
          <p className="mt-6 text-brand-light/60 text-sm font-medium" data-id="element-112">
            One-time payment. Instant delivery. Secure your future now.
          </p>
        </motion.div>
      </div>
    </section>;
};